import styled from 'vue-styled-components';

export const ComponentWrapper = styled.div``;
